import axios from 'axios';
import md5 from 'md5';

export class ServiceApi {
  static post(address, body) {
    return axios
      .post(`${window.config.servico}/${address}`, body, this._getHeaders())
      .then(
        resp => {
          return { data: resp.data };
        },
        error => {
          let errorObject = Object.assign({}, error).response;
          if (errorObject) return { error: errorObject.data.Message };
          return { error: 'Erro interno do servidor.' };
        }
      );
  }

  static get(address) {
    return axios
      .get(`${window.config.servico}/${address}`, this._getHeaders())
      .then(
        resp => {
          return resp.data;
        },
        error => {
          let errorObject = Object.assign({}, error).response;

          if (errorObject) {
            if (errorObject.data.Message) return { error: errorObject.data };

            if (errorObject.data) return { error: errorObject.data };

            return { error: 'Erro interno do servidor.' };
          }
        }
      );
  }

  static _getHeaders() {
    const auth = JSON.parse(`${sessionStorage.getItem('auth')}`);
    if (auth) {
      return {
        headers: {
          user: auth.Login,
          Cnonce: auth.Cnonce,
          Token: md5(auth.Login + auth.Cnonce + auth.Token),
        },
      };
    } else return undefined;
  }
}
